import React from 'react';
import styled from 'styled-components';

import { AppBranding } from '../types/appBranding';
import LoadingHeader from '../hocs/ApplicationWrapper/Components/Header/LoadingHeader';
import LoadingPage from '../components/LoadingPage/LoadingPage';

// Fill the viewport so the loader can center against a definite height. The
// loader sits in an absolutely-positioned layer covering the full viewport so
// it stays dead-centered regardless of the header, matching the pre-init-gate
// behaviour where LoadingPage was rendered directly into a full-height root.
const Page = styled.div`
	position: relative;
	height: 100vh;
	width: 100%;
`;

const LoaderLayer = styled.div`
	position: absolute;
	inset: 0;
`;

export const UnauthorizedLoadingPage = ({
	branding,
}: {
	branding?: AppBranding;
}) => (
	<Page data-cy="unauthorized-loading-page">
		<LoadingHeader branding={branding} />
		<LoaderLayer>
			<LoadingPage />
		</LoaderLayer>
	</Page>
);
